import { SideNavigation } from "@cloudscape-design/components";
import { useAuth } from "./AuthContext";

export function NavigationSide({ activeHref }) {
    const { logout } = useAuth();
    
    return (
      <SideNavigation
        activeHref={activeHref}
        header={{ text: 'AWS Eloquence', href: '/' }}
        onFollow={
          (event) => {
            if (event.detail.href.includes("/logout")) {
              event.preventDefault();
              logout();
            }
          }
        }
        items={[
          { type: 'link', text: 'Learn More', href: '/learnmore' },
          { type: 'link', text: 'Get Started', href: '/getstarted' },
          { type: 'link', text: 'My Meetings', href: '/meetings' },
          { type: 'link', text: 'Voice Assistant', href: '/voice-assistant' },
          { type: 'divider' },
          { type: 'link', text: 'Documentation', href: '/documentation' },
          { type: 'divider' },
          { type: 'link', text: 'Logout', href: "/logout" },
        ]}
      />
    );
  }
  
